import {Attendee} from 'Event/attendee'
import styled from 'styled-components'
import Page from 'Event/template/Townhall/Page'
import React from 'react'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TableBody from '@material-ui/core/TableBody'
import {useAttendeeVariables} from 'Event'
import {PageTitle, PageDescription} from 'Event/template/Townhall/Page'
import {useTownhallTemplate} from 'Event/template/Townhall'
import Content from 'lib/ui/form/TextEditor/Content'
import {eventRoutes} from 'Event/Routes'
import {RelativeLink} from 'lib/ui/link/RelativeLink'
import {useEntries} from 'Event/Leaderboard'
import {TownhallBreadcrumbs} from 'Event/template/Townhall/Page'

export default function TownhallLeaderboard(props: {user: Attendee}) {
  const {entries} = useEntries()
  const template = useTownhallTemplate()
  const {leaderboard: leaderboardPage, textColor} = template

  const v = useAttendeeVariables()

  let description = v(leaderboardPage.description)

  return (
    <Page user={props.user}>
      <PageTitle>{v(leaderboardPage.title)}</PageTitle>
      <TownhallBreadcrumbs page={v(leaderboardPage.title)} />
      <PageDescription description={description}>
        <Content>{description}</Content>
      </PageDescription>
      <StyledRelativeLink
        to={eventRoutes.root}
        color={leaderboardPage.backToDashboardTextColor}
      >
        {v(leaderboardPage.backToDashboardText)}
      </StyledRelativeLink>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell color={textColor}>#</StyledTableCell>
            <StyledTableCell align="left" color={textColor}>
              Name
            </StyledTableCell>
            <StyledTableCell align="right" size="small" color={textColor}>
              Points
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.map((entry, index) => (
            <TableRow key={index} aria-label="entry">
              <StyledTableCell component="th" scope="row" color={textColor}>
                {index + 1}
              </StyledTableCell>
              <StyledTableCell align="left" color={textColor}>
                {entry.attendee.first_name} {entry.attendee.last_name}
              </StyledTableCell>
              <StyledTableCell align="right" color={textColor}>
                {entry.score}
              </StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Page>
  )
}

const StyledRelativeLink = styled((props) => {
  const {color: _1, ...otherProps} = props

  return <RelativeLink {...otherProps} />
})`
  line-height: 1.5;
  margin-bottom: 20px;
  color: ${(props) => props.color} !important;
`

const StyledTableCell = styled(TableCell)<{color: string}>`
  color: ${(props) => props.color};
`
